import { render, staticRenderFns } from "./GestorTurnos.vue?vue&type=template&id=22ebd4d6&"
import script from "./GestorTurnos.vue?vue&type=script&lang=js&"
export * from "./GestorTurnos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports